import { DescuentoRecargo } from "./DescuentoRecargo";
import { DetalleDte } from "./DetalleDte";
import { ClausulaVentas } from "./Exportacion/ClausulaVentas";
import { ExportacionTransporteDte } from "./exportacionDte";
import { OptionsReferenceDteEmitido } from "./OptionsReferenceDteEmitido";
import { OtraMoneda } from "./OtraMoneda";
import { TipoDespachoEnum } from "./TipoDespacho.enum";

export class TotalDteEmitido {
	//class used in individual request for invoice
	tipoDteId: string;
	codigoTipoDte: number;
	formaPago: number;
	formaPagoExportacion: number;
	fechaEmision: Date;
	descuentoGlobal: number;
	netoDte: number;
	exentoDte: number;
	ivaDte: number;
	TieneIvaTerceros: boolean;
	ivaTerceros: number;
	ivaPropio: number;
	totalDte: number;
	formato: any;
	diasVencimiento: number;
	otraMonedaEnt: OtraMoneda;
	descuentoRecargoEnt: DescuentoRecargo;
	montoImpuestos: number;
	retencionIva: number;
	tipoTraslado: number;
	tipoDespacho: TipoDespachoEnum;
	modalidadVentaId: number;
	modalidadVentaNombre: string;
	indicadorServicio: number;
	clausulaVenta: any;
	montoClausulaVenta: any;
	clausulaVentaObj: ClausulaVentas;
	clausulaVentaId: number;
	clausulaVentaGlosa: string;
	codigoClausulaVenta: number;
	codigoModalidadVenta: number;
	totalComisionCargos: number;
	ivaComisionCargos: number;
	netoComisionCargos: number;
	exentoComisionCargos: number;
	tieneRetenciones() {
		const netoDte = Number(this.netoDte || 0);
		const exentoDte = Number(this.exentoDte || 0);
		const ivaDte = Number(this.ivaDte || 0);
		const montoImpuestos = Number(this.montoImpuestos || 0);
		const retencionIva = Number(this.retencionIva || this.ivaDte);
		return netoDte + exentoDte + ivaDte + montoImpuestos - retencionIva;
	}
	
	calcularRetenciones(lista: DetalleDte[], esNeto: boolean, mainTax: number) {
		let retencionTotal = 0;
		if (esNeto) {
			lista.forEach((detalle) => {
				if (detalle.retenciones && detalle.retenciones.length > 0) {
					detalle.retenciones.forEach((ret) => {
						retencionTotal += !detalle.esExento ? Math.round(detalle.cantidad * detalle.precioUnitario * (detalle.porcentajeRetencion / 100)) : 0;
					});
				} else {
					retencionTotal += !detalle.esExento ? Math.round(detalle.cantidad * detalle.precioUnitario * (detalle.porcentajeRetencion / 100)) : 0;
				}
			});
		} else {
			lista.forEach((detalle) => {
				let sumTaxRates = 0;
				if (detalle.impuestosAdicionales) {
					detalle.impuestosAdicionales.forEach((imp) => {
						sumTaxRates += imp.tasa;
					});
				}
				let netoOfDetalle = 0;
				netoOfDetalle = Math.round(detalle.cantidad * detalle.precioUnitario) / (1 + sumTaxRates / 100 + mainTax);
				if (detalle.retenciones && detalle.retenciones.length > 0) {
					detalle.retenciones.forEach((ret) => {
						retencionTotal += !detalle.esExento ? Math.round(netoOfDetalle * (detalle.porcentajeRetencion / 100)) : 0;
					});
				} else {
					retencionTotal += !detalle.esExento ? Math.round(netoOfDetalle * (detalle.porcentajeRetencion / 100)) : 0;
				}
			});
		}
		return retencionTotal;
	}

	calcularClausulaVenta(transporte: ExportacionTransporteDte, opciones: OptionsReferenceDteEmitido, otraMoneda: OtraMoneda) {
		let flete = transporte != undefined ? transporte.flete : 0;
		let seguro = transporte != undefined ? transporte.seguro : 0;
		// if(opciones.tipoMoneda!='CLP'){
		//   flete = Math.round(transporte.flete*otraMoneda.tipoCambio);
		//   seguro = Math.round(transporte.seguro*otraMoneda.tipoCambio);
		// }
		if (this.clausulaVentaObj) {
			switch (this.clausulaVentaObj.sigla) {
				case "FOB":
					this.montoClausulaVenta = this.totalDte;
					break;
				case "CIF":
					this.montoClausulaVenta = this.totalDte + (flete ? +flete : 0) + (seguro ? +seguro : 0);
					break;
				case "CFR":
					this.montoClausulaVenta = this.totalDte + flete;
					break;
				case "EXW":
					this.montoClausulaVenta = this.totalDte;
					break;
				case "FAS":
					this.montoClausulaVenta = this.totalDte;
					break;
				case "SCL":
					this.montoClausulaVenta = this.totalDte;
					break;
				case "FCA":
					this.montoClausulaVenta = this.totalDte;
					break;
				case "DDP":
					this.montoClausulaVenta = this.totalDte;
					break;
				default:
					break;
			}
		} else {
			this.montoClausulaVenta = 0;
		}
	}
}
